export const WORLD_STATE = {
  ACTIVE: 'UNLOCKED',
  COMPLETE: 'COMPLETED'
}
